module.exports = __webpack_public_path__ + "static/media/compound-import-popup.595ad880.png";